import {useEffect} from 'react'
import useAsync from '../../commerce-api/hooks/useAsync'
import useOcapiSite from '../../hooks/useOcapiSite'
import {useBazaarvoiceAPI} from '../context'

const useProductReviewOverview = (productId) => {
    const {bvEnabled} = useOcapiSite()
    const {getProductReviewOverview} = useBazaarvoiceAPI()
    const {data, error, loading, execute, reset} = useAsync(getProductReviewOverview)

    useEffect(() => {
        if (!productId || !bvEnabled) {
            reset()
            return
        }

        const abortController = new AbortController()
        execute(productId, {signal: abortController.signal})
        return () => {
            abortController.abort()
        }
    }, [bvEnabled, execute, productId, reset])

    return {
        data,
        error,
        loading
    }
}

export default useProductReviewOverview
